import React from "react";
import PropTypes from "prop-types";
import {AButton} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {t} from "i18next";
import {noop} from "lodash-es";
import TooltipDelay from "components/TooltipDelay";
import {getUTCDate} from "utils/dateutils";
import css from "./FirstSeenCol.module.scss";

const FirstSeenCol = ({event, handleClick = noop}) => {
  const date = event?.observed_time?.start_time;

  return (
    <TooltipDelay
      title={t("incidents.table.firstSeen")}
      subtitle={getUTCDate(date)}>
      <AButton
        className={classNames(css.firstSeenBtn, "px-0 d-inline")}
        tertiary
        onClick={() => handleClick(event)}>
        {getUTCDate(date)}
      </AButton>
    </TooltipDelay>
  );
};

export default FirstSeenCol;

FirstSeenCol.propTypes = {
  event: PropTypes.object,
  handleClick: PropTypes.func
};
